import { CSApiService } from "../../redux-store/CSApiService";
import {
  Api_CMS_ClaimProcessDocument,
  APi_CMS_ErrorDetails,
  APi_CMS_IntegrationVariables,
  Api_CMS_NpsFeedBack,
  Api_CMS_Onboarding_Animation,
  Api_CMS_PageMessages,
  APi_CMS_PageVariables,
  Api_HL_SuccessMessages,
  Api_Fetch_My_Track,
  Api_Fetch_Top_Banner,
  Api_Fetch_Center_Banner,
  Api_Fetch_New_Offering,
  Api_Fetch_Footer_Banner,
  Api_Fetch_L2_Banner,
  Api_Fetch_Nudge_Banner,
} from "../../utils/ApiEndpoints";
import { T_ApiResponse } from "../../globalTypes/GlobalTypes";
import {
  T_ClaimProcessDocument_Request,
  T_ClaimProcessDocument_Response,
  T_CmsErrorResponse,
  T_CmsCenterBanner_Request,
  T_CmsFetchCenterBanner_Response,
  T_CmsFetchOnboardingAnimations_Response,
  T_CmsFetchTopBanner_Response,
  T_CmsFooterBanner_Response,
  T_CmsHlSuccessMessagesApiResponse,
  T_CmsIntegrationVariablesApiResponse,
  T_CmsL2Banner_Request,
  T_CmsL2Banner_Response,
  T_CmsNewOffering_Response,
  T_CmsNpsFeedback_Response,
  T_CmsNudgeBanner_Response,
  T_CmsPageMessageApiResponse,
  T_CmsPageVariablesResponse,
  T_CmsTrackWhatMatters_Response,
} from "./CmsGlobal.Types";

export const cmsApi = CSApiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchIntegrationVariable: builder.query<
      T_CmsIntegrationVariablesApiResponse,
      void
    >({
      query: () => ({
        url: APi_CMS_IntegrationVariables,
        method: "POST",
      }),
      //providesTags: ['CMS_Integration_VARIABLES_DATA'],
    }),
    fetchPageVariable: builder.query<T_CmsPageVariablesResponse, void>({
      query: () => ({
        url: APi_CMS_PageVariables,
        method: "POST",
      }),
      //providesTags: ['CMS_PAGE_VARIABLES_DATA'],
    }),
    fetchErrorVariable: builder.query<T_CmsErrorResponse, void>({
      query: () => ({
        url: APi_CMS_ErrorDetails,
        method: "POST",
      }),
      //providesTags: ['CMS_PAGE_VARIABLES_DATA'],
    }),
    fetchPageMessage: builder.query<T_CmsPageMessageApiResponse, void>({
      query: () => ({
        url: Api_CMS_PageMessages,
        method: "POST",
      }),
      //providesTags: ['CMS_PAGE_VARIABLES_DATA'],
    }),
    fetchNpsFeedback: builder.query<T_CmsNpsFeedback_Response, void>({
      query: () => ({
        url: Api_CMS_NpsFeedBack,
        method: "POST",
      }),
    }),
    fetchHlSuccessMessages: builder.query<
      T_CmsHlSuccessMessagesApiResponse,
      void
    >({
      query: () => ({
        url: Api_HL_SuccessMessages,
        method: "POST",
      }),
    }),
    fetchClaimProcessDocuments: builder.query<
      T_ApiResponse<T_ClaimProcessDocument_Response>,
      T_ClaimProcessDocument_Request
    >({
      query: (payload) => ({
        url: Api_CMS_ClaimProcessDocument,
        method: "POST",
        body: payload,
      }),
    }),
    fetchMyTrack: builder.query<T_CmsTrackWhatMatters_Response, void>({
      query: () => ({
        method: "POST",
        url: Api_Fetch_My_Track,
      }),
    }),
    fetchTopBanner: builder.query<T_CmsFetchTopBanner_Response, void>({
      query: () => ({
        method: "POST",
        url: Api_Fetch_Top_Banner,
      }),
    }),
    fetchCenterBanner: builder.query<
      T_CmsFetchCenterBanner_Response,
      T_CmsCenterBanner_Request
    >({
      query: (payload) => ({
        method: "POST",
        url: Api_Fetch_Center_Banner,
        body: payload,
      }),
    }),
    fetchNewOffering: builder.query<T_CmsNewOffering_Response, void>({
      query: () => ({
        method: "POST",
        url: Api_Fetch_New_Offering,
      }),
    }),
    fetchFooterBanner: builder.query<T_CmsFooterBanner_Response, void>({
      query: () => ({
        method: "POST",
        url: Api_Fetch_Footer_Banner,
      }),
    }),
    fetchL2Banner: builder.query<T_CmsL2Banner_Response, T_CmsL2Banner_Request>(
      {
        query: (payload) => ({
          method: "POST",
          url: Api_Fetch_L2_Banner,
          body: payload,
        }),
      },
    ),
    fetchNudgeBanner: builder.query<T_CmsNudgeBanner_Response, void>({
      query: () => ({
        method: "POST",
        url: Api_Fetch_Nudge_Banner,
      }),
    }),
    fetchOnboardingAnimations: builder.query<
      T_CmsFetchOnboardingAnimations_Response,
      void
    >({
      query: () => ({
        method: "POST",
        url: Api_CMS_Onboarding_Animation,
      }),
    }),
  }),
});

export const {
  useLazyFetchIntegrationVariableQuery,
  useLazyFetchPageVariableQuery,
  useLazyFetchErrorVariableQuery,
  useLazyFetchPageMessageQuery,
  useLazyFetchNpsFeedbackQuery,
  useLazyFetchHlSuccessMessagesQuery,
  useLazyFetchClaimProcessDocumentsQuery,
  useLazyFetchMyTrackQuery,
  useLazyFetchTopBannerQuery,
  useLazyFetchCenterBannerQuery,
  useLazyFetchNewOfferingQuery,
  useLazyFetchFooterBannerQuery,
  useLazyFetchL2BannerQuery,
  useLazyFetchNudgeBannerQuery,
  useLazyFetchOnboardingAnimationsQuery,
} = cmsApi;
